import { render, staticRenderFns } from "./my_goods.vue?vue&type=template&id=39cea0cf&scoped=true&"
import script from "./my_goods.vue?vue&type=script&lang=js&"
export * from "./my_goods.vue?vue&type=script&lang=js&"
import style0 from "./my_goods.vue?vue&type=style&index=0&id=39cea0cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cea0cf",
  null
  
)

export default component.exports